<template>
    <div>
        <p class="timeline-talks">{{ message }}</p>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            if (
                this.details.type == 'name_screening_rejected' ||
                this.details.type == 'name_screening_approved'
            ) {
                return (
                    'Name Screening Hit applied with the ' +
                    this.details.action +
                    ' result.'
                )
            }
            return ''
        },
    },
}
</script>
